import { motion, useMotionValue, useSpring, useTransform } from "framer-motion";

const Book3D = () => {
  const mx = useMotionValue(0);
  const my = useMotionValue(0);
  const rotateY = useSpring(useTransform(mx, [-0.5, 0.5], [-38, -10]), { stiffness: 60, damping: 18 });
  const rotateX = useSpring(useTransform(my, [-0.5, 0.5], [14, 2]), { stiffness: 60, damping: 18 });

  const onMove = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    mx.set((e.clientX - r.left) / r.width - 0.5);
    my.set((e.clientY - r.top) / r.height - 0.5);
  };
  const onLeave = () => {
    mx.set(-0.18);
    my.set(0.1);
  };

  return (
    <div
      className="book-scene w-full h-full flex items-center justify-center"
      onMouseMove={onMove}
      onMouseLeave={onLeave}
      data-testid="book-3d-scene"
    >
      <motion.div
        animate={{ y: [0, -16, 0] }}
        transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
      >
        <motion.div
          className="book-3d"
          style={{ rotateY, rotateX, width: 300, height: 440 }}
          initial={{ rotateY: -24, rotateX: 8 }}
        >
          {/* Front cover */}
          <div
            className="book-face book-front flex flex-col justify-between px-8 py-10"
            style={{ width: 300, height: 440, transform: "translateZ(26px)" }}
            data-testid="book-front-cover"
          >
            <div>
              <div className="h-px w-16 bg-[#00FF8F]/70 mb-8" />
              <p className="font-mono-tech text-[9px] uppercase tracking-[0.35em] text-[#00FF8F] mb-5">
                The Joe Fenix Method
              </p>
              <h3 className="font-serif-display text-white text-3xl leading-tight font-medium">
                High Somatic
                <br />
                Mastery
              </h3>
              <p className="font-serif-display italic text-[#00FF8F] text-4xl mt-3 leading-none">
                Zero Cortisol
              </p>
            </div>
            <div>
              <div className="h-px w-full bg-gradient-to-r from-[#00FF8F]/50 to-transparent mb-4" />
              <p className="font-mono-tech text-[10px] uppercase tracking-[0.4em] text-[#A6A6AD]">
                Joe Fenix
              </p>
            </div>
          </div>
          {/* Back cover */}
          <div
            className="book-face book-back"
            style={{ width: 300, height: 440, transform: "translateZ(-26px) rotateY(180deg)" }}
          />
          {/* Spine */}
          <div
            className="book-face book-spine flex items-center justify-center"
            style={{ width: 52, height: 440, transform: "rotateY(-90deg) translateZ(26px)", left: 0 }}
          >
            <span
              className="font-mono-tech text-[9px] uppercase tracking-[0.4em] text-[#0A0A0A]"
              style={{ writingMode: "vertical-rl" }}
            >
              High Somatic Mastery — Zero Cortisol
            </span>
          </div>
          {/* Pages */}
          <div
            className="book-face book-pages"
            style={{
              width: 50,
              height: 432,
              top: 4,
              transform: "rotateY(90deg) translateZ(274px)",
              left: 0,
            }}
          />
        </motion.div>
      </motion.div>
    </div>
  );
};

export default Book3D;
